import { call, put, takeLatest } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import { acceptInvite, acceptOrgInvite, verifyInviteToken, resendInvite } from './acceptInvite.reducer'
import Api from '../../services/ApiCaller'
import { showErrorMessage, showMessage } from '../../utils'
import { translate } from '../../i18n'

export function* verifyInviteTokenRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(verifyInviteToken.success(res))
    } else {
      yield put(verifyInviteToken.failure(message))
    }
  } catch (e) {
    yield put(verifyInviteToken.failure(e.message))
  }
}

export function* acceptInviteRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(acceptInvite.success(res))
      showMessage(`${translate('acceptInvite.SuccessfulInvitationAccept')}`)
      yield put(push('/login'))
    } else {
      yield put(acceptInvite.failure(message))
    }
  } catch (e) {
    yield put(acceptInvite.failure(e.message))
  }
}

export function* acceptOrgInviteRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(acceptOrgInvite.success(res))
      showMessage(`${translate('acceptInvite.SuccessfulInvitationAccept')}`)
      yield put(push('/login'))
    } else {
      yield put(acceptOrgInvite.failure(message))
    }
  } catch (e) {
    yield put(acceptOrgInvite.failure(e.message))
  }
}
export function* resendInviteRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(resendInvite.success(res))
      showMessage(`${translate('resendInvite.resendInviteSuccess')}`)
    } else {
      showErrorMessage(message)
      yield put(resendInvite.failure(message))
    }
  } catch (e) {
    yield put(resendInvite.failure(e.message))
  }
}

export default (api: any) => {
  const verifyInviteTokenApi = (data: any) =>
    api.get('/users/verify', data)

  const acceptInviteApi = (data: any) =>
    api.post(`/users/signup?token=${data.token}`, data)

  const acceptOrgInviteApi = (data: any) =>
    api.post(`/organizations/signup?token=${data.token}`, data)

  const resendInviteApi = (data: any) =>
    api.get(`/users/resend-invite/${data.userId}`, data)

  return [
    takeLatest(
      verifyInviteToken.TRIGGER,
      verifyInviteTokenRequest,
      verifyInviteTokenApi
    ),
    takeLatest(acceptInvite.TRIGGER, acceptInviteRequest, acceptInviteApi),
    takeLatest(acceptOrgInvite.TRIGGER, acceptOrgInviteRequest, acceptOrgInviteApi),
    takeLatest(resendInvite.TRIGGER, resendInviteRequest, resendInviteApi)
  ]
}
